import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

type Params = {
  id: string | undefined;
};

const useDeleteEOB = ({ id }: Params) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      if (!id) {
        throw new Error('ID is required');
      }
      const { data } = await axios.post(`assistance_requests/${id}/delete_eob`);
      return data;
    },
    retry: (failureCount, error) => {
      // Don't retry if ID is missing
      if (error instanceof Error && error.message === 'ID is required') {
        return false;
      }
      return failureCount < 2;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['assistance-request-detail', id?.toString()],
      });
    },
  });
};

export default useDeleteEOB;
